document.addEventListener('DOMContentLoaded', () => {
  // Locale form handling
  const localeForm = document.getElementById('HeaderLanguageForm');
  if (localeForm) {
    const select = localeForm.querySelector('select');
    select.addEventListener('change', () => {
      localeForm.submit();
    });
  }

  // Intersection Observer for Scroll Animations
  const animationObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Run once
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });

  const animatedElements = document.querySelectorAll('.animate-on-scroll');
  animatedElements.forEach(el => {
    animationObserver.observe(el);
  });

  // Hero Parallax Implementation
  const initHeroParallax = () => {
    const heroSections = document.querySelectorAll('.hero-parallax-section');
    if (!heroSections.length) return;

    // Parallax logic only - do not pause video for reduced motion per user request
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    heroSections.forEach(section => {
      const video = section.querySelector('video');
      const parallaxEl = section.querySelector('.parallax-element');
      const strength = parseFloat(section.dataset.parallaxStrength) || 0;

      // Ensure video plays (browser policy fallback)
      if (video) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Auto-play was prevented, show fallback/poster
            console.log('Video play prevented by browser');
          });
        }
      }

      if (!parallaxEl || strength === 0 || prefersReducedMotion) return;

      let scrollY = window.pageYOffset;
      let isVisible = false;

      // Observe visibility to save performance
      const observer = new IntersectionObserver((entries) => {
        isVisible = entries[0].isIntersecting;
      }, { threshold: 0 });

      observer.observe(section);

      const updateParallax = () => {
        if (isVisible) {
          scrollY = window.pageYOffset;
          const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
          const relativeScroll = scrollY - sectionTop;

          // Calculate displacement within bounds
          const displacement = relativeScroll * strength;

          // Apply transform: translate maintaining the -50% base centering
          parallaxEl.style.transform = `translate3d(-50%, calc(-50% + ${displacement}px), 0)`;
        }
        requestAnimationFrame(updateParallax);
      };

      requestAnimationFrame(updateParallax);
    });
  };

  initHeroParallax();
});
